import React from 'react'
import MomentFormatter from '../../formatters/MomentFormatter'
import Styling from '../../styling'
import Avatar from '../users/Avatar'
import InputDefault from '../forms/InputDefault'
import ButtonWSpinner from '../buttons/ButtonWSpinner'

export default function CardWThread(props) {
  const {
    className,
    authorImageURL,
    authorImageAlt,
    authorUsername,
    authorImageWidth,
    authorImageHeight,
    description,
    publishedAt,
    content,
    commentList,
    authorNotCenteredInMobile = false,
    commentCreateForm,
  } = props
  return (
    <>
      <div className={`_wrapper ${Styling.backgrounds.light} ${className} p-4 border-b-1 border-b-primary/30`}>
        <div className={`_mainThread grid gap-4`}>
          <div className={`_author`}>
            <Avatar
              authorNotCenteredInMobile={authorNotCenteredInMobile}
              imageURL={authorImageURL}
              imageAlt={`${authorUsername} profile image`}
              imageWidth={authorImageWidth}
              imageHeight={authorImageHeight}
              username={authorUsername}
              description={<>{description} <MomentFormatter date={publishedAt} /></>}
            />
          </div>
          <div className={`_content ${Styling.sizes.sm.default}`}>
            {content}
          </div>
        </div>


        {commentList?.length > 0 && (
          <div className={`_commentList py-4 px-4 ${Styling.backgrounds.base} mt-4 grid gap-6`}>

            {commentList.map((comment, index) => {
              return (
                <div key={index} className={`_comment grid gap-4`}>
                  <Avatar
                    imageURL={comment.url}
                    imageAlt={`${comment.name} profile image`}
                    imageWidth={authorImageWidth}
                    imageHeight={authorImageHeight}
                    username={comment.name}
                    description={<MomentFormatter date={comment.publishedAt} fromNow />}
                  />
                  <div className={`_content ${Styling.sizes.sm.default}`}>
                    {comment.content}
                  </div>
                </div>
              )
            })}
          </div>
        )}
        {commentCreateForm && (
          <div className={`_commentCreate`}>
            {commentCreateForm}
          </div>

        )}



      </div>
    </>
  )
}
